import { forOwn, isObject } from 'lodash'
import { attr } from '../modelizer'

export const Base = class {
  constructor(...props) {
    const [model, data] = props
    forOwn(data, (value, key) => {
      if (model.hasOwnProperty(key)) {
        if (isObject(model[key]) && typeof model[key] !== 'function') {
          forOwn(data[key], (objValue, objKey) => {
            data[key][objKey] = attr(
              objKey,
              model[key][objKey],
              objValue,
              data[key]
            )
          })
        }
        this[key] = attr(key, model[key], value, data)
      } else {
        this[key] = value
      }
    })
  }
}

export default Base



// WEBPACK FOOTER //
// ./src/store/serializers/base.js